/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import { supabase } from "utils/supabase";
import { getDeviceId } from "utils/devices";
import { useHistory } from "react-router-dom";

const UserDropdown = () => {
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
  const btnDropdownRef = useRef(null);
  const popoverDropdownRef = useRef(null);
  const history = useHistory();

  const openDropdownPopover = () => {
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownPopoverShow &&
        btnDropdownRef.current &&
        popoverDropdownRef.current &&
        !btnDropdownRef.current.contains(event.target) &&
        !popoverDropdownRef.current.contains(event.target)
      ) {
        closeDropdownPopover();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [dropdownPopoverShow]);

  const handleLogout = async () => {
    await supabase.rpc("end_device_session", {
      p_device_id: getDeviceId(),
    });
    await supabase.auth.signOut()
    history.push("/auth");
  }

  return (
    <>
      <div className="relative inline-block">
      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="items-center flex">
          <span className="w-10 h-10 text-sm text-white inline-flex items-center justify-center rounded-full">
            <i className="fas fa-user-md text-xl"></i>
          </span>
        </div>
      </a>
      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "absolute right-0 mt-2 bg-white text-base z-50 py-2 list-none text-left rounded shadow-lg w-56 sm:w-64 max-w-[calc(100vw-16px)]"
        }
      >
        <a
          href="/admin/mi-cuenta"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            e.preventDefault();
            closeDropdownPopover();
            history.push("/admin/mi-cuenta");
          }}
        >
          Mi cuenta
        </a>
        <a
          href="/faq"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={(e) => {
            e.preventDefault();
            closeDropdownPopover();
            history.push("/faq");
          }}
        >
          Ayuda / FAQ
        </a>
        <div className="h-0 my-2 border border-solid border-blueGray-100" />
        <a
          href="#"
          className={
            "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
          }
          onClick={handleLogout}
        >
          Cerrar sesión
        </a>
      </div>
      </div>
    </>
  );
};

export default UserDropdown;
